import { useState, type FormEvent } from "react";
import { ArrowRight, LockKeyhole } from "lucide-react";
import { login } from "../api";

export function LoginPage({ onAuthenticated }: { onAuthenticated: () => void }) {
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);
  const submit = async (event: FormEvent) => {
    event.preventDefault();
    setBusy(true); setError("");
    try { await login(password); onAuthenticated(); }
    catch (reason) { setError(reason instanceof Error ? reason.message : "Sign in failed"); }
    finally { setBusy(false); }
  };
  return <main className="login-page">
    <div className="login-brand"><span className="monogram">SD</span><span>StrategyDepartment</span></div>
    <section className="login-panel">
      <div className="login-panel__mark"><LockKeyhole aria-hidden="true" /></div>
      <span className="eyebrow">Private reference library</span>
      <h1>Enter the department.</h1>
      <p>Reference intelligence, ingestion progress, and production artifacts are protected behind one shared operator password.</p>
      <form onSubmit={(event) => void submit(event)}>
        <label htmlFor="password">Password</label>
        <div className="login-field"><input id="password" type="password" autoComplete="current-password" autoFocus value={password} onChange={(event) => setPassword(event.target.value)} aria-describedby={error ? "login-error" : undefined} /><button type="submit" disabled={busy || !password}>{busy ? "Checking…" : "Enter"}<ArrowRight size={17} /></button></div>
        {error && <p id="login-error" className="field-error" role="alert">{error}</p>}
      </form>
    </section>
    <p className="login-footnote">Authorized operators only</p>
  </main>;
}
